import {X} from "react-feather";
import {Container} from "./styled";

interface UIErrorBoundaryProps {}

export const UIErrorBoundary: React.FC<UIErrorBoundaryProps> = () => {
  return (
    <Container>
      <X size={35} />
      <h2>Oh no. Ha sucedido un error</h2>
      <p>
        por favor refresca la página. En caso de persistir, vuelve al inicio
        presionando <a href="/resume">aquí</a>
      </p>
    </Container>
  );
};
